import { useState } from 'react';
import { Bell } from 'lucide-react';
import NotificationItem from './NotificationItem';

const NotificationsDropdown = ({ notifications, setNotifications }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const handleMarkAsRead = (id) => {
      setNotifications(notifications.map(n => 
        n.id === id ? { ...n, read: true } : n
      ));
    };
  
    const handleDelete = (id) => {
      setNotifications(notifications.filter(n => n.id !== id));
    };
  
    const handleMarkAllAsRead = () => {
      setNotifications(notifications.map(n => ({ ...n, read: true })));
    };
  
    const handleDeleteAll = () => {
      setNotifications([]);
    };
  
    const unreadCount = notifications.filter(n => !n.read).length;
  
    return (
      <div className="relative">
        <button 
          className="relative p-1 rounded-full text-gray-500 hover:bg-gray-100 mr-5"
          onClick={() => setIsOpen(!isOpen)}
        >
          <Bell className="w-6 h-6" />
          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 block h-5 w-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">
              {unreadCount}
            </span>
          )}
        </button>
  
        {isOpen && (
          <div className="absolute right-0 mt-2 w-80 bg-white rounded-md shadow-lg z-50 overflow-hidden border border-gray-200">
            <div className="p-3 border-b border-gray-200 flex justify-between items-center">
              <h3 className="text-sm font-semibold">Notifications</h3>
              <div className="flex space-x-2">
                <button 
                  onClick={handleMarkAllAsRead}
                  className="text-xs text-blue-600 hover:text-blue-800"
                  disabled={unreadCount === 0}
                >
                  Tout marquer comme lu
                </button>
                <button 
                  onClick={handleDeleteAll}
                  className="text-xs text-red-600 hover:text-red-800"
                  disabled={notifications.length === 0}
                >
                  Tout supprimer
                </button>
              </div>
            </div>
            
            <div className="max-h-96 overflow-y-auto">
              {notifications.length > 0 ? (
                notifications.map(notification => (
                  <NotificationItem 
                    key={notification.id} 
                    notification={notification}
                    onMarkAsRead={handleMarkAsRead}
                    onDelete={handleDelete}
                  />
                ))
              ) : (
                <div className="p-4 text-center text-gray-500 text-sm">
                  Aucune notification
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

export default NotificationsDropdown;